import { ViewConfiguration } from '../../../../grid/gridView/types';
import { ColumnDetails } from '../../../../grid/types/common';
import { QueryExecution } from '../../types';

export enum Column {
  ENDPOINT,
}

export enum ColumnKeys {
  ENDPOINT = 'endpoint',
}

export const DEFAULT_PAGE_SIZE = 50;

export interface LiveSearchResultsGridViewData {
  views: Array<ViewConfiguration<any, any>>;
  allColumns: Array<ColumnDetails<any, any>>;
  defaultViewProps: ViewConfiguration<any, any>;
  queryExecution: QueryExecution | null;
}

export interface LiveSearchResultsGridGetRowsResponse {
  rawEvents?: Array<any>;
}

export enum Events {
  CLICK_ON_ENDPOINT_IN_GIRD = 'clickOnEndpointInGrid',
}
